import { apiRequest } from '@/utils/api-request';

interface ValidateOtpProps {
  email: string;
  code: string;
}

export const validateOtp = async ({ email, code }: ValidateOtpProps) => {
  const response = await apiRequest({
    url: '/user/otp/validate',
    method: 'POST',
    target: 'platform',
    body: {
      email: email?.toLowerCase(),
      code: code,
    },
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to validate OTP' };
  }

  return response;
};
